import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, units } from '@calm-web/design-system';

import LightningBoltIcon from 'icons/lightning-filled.svg';
import TimeIcon from 'icons/time-filled-white.svg';

export const TrendingAndRecentsContainer = styled.div`
	padding-bottom: ${units(4)};
	width: 100%;
`;

export const TrendingAndRecentsTitle = styled.h5`
	color: ${palette('adaptiveText', 'white')};
	margin-bottom: ${units(1)};
	${fontWeight(FontWeights.Medium)};
`;

export const TitleLineDelimiter = styled.hr`
	border: 1;
	height: 0.5px;
	background-color: ${palette('gray', 2)};
	margin-bottom: ${units(1)};
	opacity: 0.5;
`;

export const TrendingAndRecentResult = styled.div`
	color: ${palette('adaptiveText', 'white')};
	margin-bottom: ${units(1.5)};
	${fontWeight(FontWeights.Medium)};
	${fontSize(FontSizes.base)};
	cursor: pointer;
`;

export const StyledLightningBoltIcon = styled(LightningBoltIcon)`
	width: 20px;
	height: 20px;
	margin-right: 10px;
	& path {
		fill: ${palette('adaptiveText', 'white')};
	}
`;

export const StyledTimeIcon = styled(TimeIcon)`
	width: 20px;
	height: 20px;
	margin-right: 10px;
	& path {
		fill: ${palette('adaptiveText', 'white')};
	}
`;
